import script from "./PropertyEstimateScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyEstimateScreen.vue?vue&type=script&setup=true&lang=js"

import "./PropertyEstimateScreen.vue?vue&type=style&index=0&id=0d64bc91&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d64bc91"]])

export default __exports__